module.exports = __webpack_public_path__ + "static/img/textBg.59ace27c.png";